import React from 'react'

import { Formik } from 'formik'

import Yup from '_zari/validation/_yup'
import { ZariContext } from '_zari/context'
import { Divider, Portlet, Col, Row, Button, Form } from '_zari/core'

import * as FacturacionService from 'services/facturacion.service'

import * as FormGroups from './formGroups'

const ValidationSchema = Yup.object().shape({
  fechaDesde: Yup.string().required(),
  fechaHasta: Yup.string().required(),
  fechaDestino: Yup.string().required()
})

const CambioFechaDocumentosSection = () => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      fechaDesde: '',
      fechaHasta: '',
      fechaDestino: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      if (!data.salida) {
        return
      }

      FacturacionService.actualizarFechasMasivo(data)
        .then(() => {
          __zariContext.snack('success', 'Se han actualizado las fechas de los documentos.')
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
        .finally(() => {
          setSubmitting(false)
          __zariContext.loader.close()
        })
    },
    [__zariContext]
  )

  return (
    <Portlet>
      <Portlet.Header title='Cambio fecha documentos' />
      <Portlet.Body>
        <Row>
          <Col md={4}>
            <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
              {({ errors, touched, isSubmitting, handleSubmit }) => (
                <Form>
                  <FormGroups.FechaDesdeFormGroup
                    iError={errors.fechaDesde}
                    iTouched={touched.fechaDesde}
                    fIsSubmitting={isSubmitting}
                  />
                  <FormGroups.FechaHastaFormGroup
                    iError={errors.fechaHasta}
                    iTouched={touched.fechaHasta}
                    fIsSubmitting={isSubmitting}
                  />
                  <Divider />
                  <FormGroups.FechaDestinoFormGroup
                    iError={errors.fechaDestino}
                    iTouched={touched.fechaDestino}
                    fIsSubmitting={isSubmitting}
                  />
                  <Row>
                    <Col md={12} className='text-right'>
                      <Button disabled={isSubmitting} onClick={handleSubmit}>
                        Procesar
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(CambioFechaDocumentosSection)
